import ListHeader from './list-header';
import ListItem from './list-item';
import { VolumeRiskTransactionsListTypes } from './types';

import cn from './list.module.css';

const VolumeRiskTransactionsList = ({
  baseCurrency,
  transationVolumes,
  currencies,
}: VolumeRiskTransactionsListTypes) => (
  <div className={cn.volumeRiskTransactionsListWrapper}>
    <ListHeader />
    {transationVolumes?.map((item) => (
      <ListItem
        key={item.id}
        item={item}
        baseCurrency={baseCurrency}
        currencies={currencies}
      />
    ))}
  </div>
);

export default VolumeRiskTransactionsList;
